import { api } from "../../../api";
import axios from "axios";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const CooperativeSetupService = {
  async getCooperativeSetup({
    search,
    status,
    startDate,
    endDate,
    pageSize,
    pageNumber,
  }) {
    try {
      let { data } = await route.get(
        `/CooperativeSetup/GetCooperativeSetup?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}&ApprovalStatus=${status}&StartDate=${startDate}&EndDate=${endDate}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      // console.log({ getCooperativeSetup: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getCooperativeComponents({
    search,
    status,
    startDate,
    endDate,
    pageSize,
    pageNumber,
  }) {
    try {
      let { data } = await route.get(
        `/CooperativeSetup/GetCooperativeComponents?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}&ApprovalStatus=${status}&StartDate=${startDate}&EndDate=${endDate}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      // console.log({ getCooperativeComponents: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getCooperativeSetupById(id) {
    try {
      let { data } = await route.get(
        `/CooperativeSetup/GetCoperativeSetupQueryById/${id}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      // console.log({ getCooperativeComponents: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async createCooperativeComponent(payload) {
    try {
      let { data } = await route.post(
        `/CooperativeSetup/SetupCooperativeComponent`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      console.log({ createCooperativeComponent: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getAllEmployees(Search = "") {
    try {
      let { data } = await axios.get(
        `https://bpmapi-dev.nlpcpfa.com/HRService/api/Employee/GetAllEmployees?PageSize=100&PageNumber=1&Search=${Search}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data.result;
    } catch (e) {
      console.log({ errEmployees: e.response.data || e });
      return [];
    }
  },
  async assignApprover(payload) {
    try {
      let { data } = await route.post(
        `/CooperativeSetup/AssignCooperativeApprovalCommand`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      console.log({ createCooperativeComponent: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
};

export default CooperativeSetupService;
